import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    localSuggestionSubtitle: {
      marginBottom: 20,
    },
  })
);

export default useStyles;
